import React, { useState } from "react";
import { PhotoColumn } from "../../components/photo-column";
import zemzemKuyusu from '../../assets/photos/mukabele/zemzem-kuyusu-600.jpg';
import mukabele1 from '../../assets/photos/mukabele/mukabele-1.jpg';
import mukabele2 from '../../assets/photos/mukabele/mukabele-4.jpg';
import mukabele3 from '../../assets/photos/mukabele/mukabele-3.jpg';
import mukabele4 from '../../assets/photos/mukabele/mukabele-7.jpg';

import zemzemKuyusuMini from '../../assets/photos/mukabele/zemzem-kuyusu-mini.jpg';
import mukabele1Mini from '../../assets/photos/mukabele/mukabele-1-mini.jpg';
import mukabele2Mini from '../../assets/photos/mukabele/mukabele-4-mini.jpg';
import mukabele3Mini from '../../assets/photos/mukabele/mukabele-3-mini.jpg';
import mukabele4Mini from '../../assets/photos/mukabele/mukabele-7-mini.jpg';

import mukabele2024_1 from '../../assets/photos/mukabele/2024/mukabele-1.jpg';
import mukabele2024_2 from '../../assets/photos/mukabele/2024/mukabele-2.jpg';
import mukabele2024_3 from '../../assets/photos/mukabele/2024/mukabele-3.jpg';
import mukabele2024_4 from '../../assets/photos/mukabele/2024/mukabele-3.jpg';
import EmbedVideo from "../gallery/embed-video";
import { Collapse } from "antd";
import { CaretRightOutlined } from '@ant-design/icons';
import "./mukabele.scss";

const { Panel } = Collapse;

const Mukabele = () => {

    const [activeKey, setActiveKey] = useState("1");

    const onChangeActiveKey = (key: any) => {
        setActiveKey(key);
    };


    return (
        <section className="mukabele-section">
            <h3 className="section-title">RAMAZAN MUKABELESİ</h3>

            <article>
                <p>1981 yılından beri Fatih Camii Kur'an Kursu talebeleri ile Mukabele-i Şerif okutuyoruz.</p>
            </article>

            <Collapse defaultActiveKey={activeKey} onChange={onChangeActiveKey} bordered={false}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ fontSize: '20px' }} rev={undefined} />}
                style={{ background: "#fff" }}
            >
                <Panel header="2024 yılına ait Fatih Camii'ndeki Mukabele-i Şerifimiz" key="1">
                    <div className="photos_content">
                        <PhotoColumn
                            imageTitle="Mukabele-i Şerif"
                            isImgSourceChange={true}
                            imageSourceList={[{ src: mukabele1Mini, width: 300 }, { src: mukabele2024_1, width: 480 }]}
                        />
                        <PhotoColumn
                            imageTitle="Mukabele-i Şerif"
                            isImgSourceChange={true}
                            imageSourceList={[{ src: mukabele1Mini, width: 300 }, { src: mukabele2024_2, width: 480 }]}
                        />
                        <PhotoColumn
                            imageTitle="Mukabele-i Şerif"
                            isImgSourceChange={true}
                            imageSourceList={[{ src: mukabele1Mini, width: 300 }, { src: mukabele2024_3, width: 480 }]}
                        />
                        <PhotoColumn
                            imageTitle="Mukabele-i Şerif"
                            isImgSourceChange={true}
                            imageSourceList={[{ src: mukabele1Mini, width: 300 }, { src: mukabele2024_4, width: 480 }]}
                        />
                    </div>
                </Panel>
                <Panel header="2023 yılına ait Fatih Camii'ndeki Mukabele-i Şerifimiz" key="2">
                    <div>
                        <div className="photos_content">
                            <PhotoColumn
                                imageTitle="Mukabele-i Şerif"
                                isImgSourceChange={true}
                                imageSourceList={[{ src: mukabele1Mini, width: 300 }, { src: mukabele1, width: 480 }]}
                            />
                            <PhotoColumn
                                imageTitle="Mukabele-i Şerif"
                                isImgSourceChange={true}
                                imageSourceList={[{ src: mukabele2Mini, width: 300 }, { src: mukabele2, width: 480 }]}
                            />
                            <PhotoColumn
                                imageTitle="Mukabele-i Şerif"
                                isImgSourceChange={true}
                                imageSourceList={[{ src: mukabele3Mini, width: 300 }, { src: mukabele3, width: 480 }]}
                            />
                            <PhotoColumn
                                imageTitle="Mukabele-i Şerif"
                                isImgSourceChange={true}
                                imageSourceList={[{ src: mukabele4Mini, width: 300 }, { src: mukabele4, width: 480 }]}
                            />
                        </div>

                        <div className="mukabele-section_videos">
                            <EmbedVideo embedId="DXgkzElPpJY" />
                            <EmbedVideo embedId="HDgZJRmBqhM" />
                        </div>

                        <figcaption className="common-figcaption">Fatih Cami'nde Mukabele-i Şerif</figcaption>
                    </div>
                </Panel>

            </Collapse>

            <PhotoColumn
                imageTitle="Zemzem Kuyusu"
                figcaptionFirstTitle="Zemzem Kuyusu"
                isImgSourceChange={true}
                imageSourceList={[{ src: zemzemKuyusuMini, width: 300 }, { src: zemzemKuyusu, width: 600 }]}
            />
        </section>
    );
}

export default Mukabele;